import { FilterRange } from '@typings/filters';

export const areRangesEqual = (
  range1: FilterRange,
  range2: FilterRange,
): boolean => {
  return range1[0] === range2[0] && range1[1] === range2[1];
};

export const validateRange = (range: FilterRange) => {
  if (range && range[0] !== null && range[1] !== null) {
    if (range[0] >= range[1]) {
      return false;
    }
  }
  return true;
};
